import { cn } from "@/src/lib/utils";

export const Card = ({ children, className, variant = "default" }) => {
  return (
    <div
      className={cn(
        "rounded-2xl p-4 sm:p-6 transition-all duration-300",
        {
          "bg-card border border-border hover:border-border/80": variant === "default",
          "bg-card/60 backdrop-blur-lg border border-border/50 hover:border-border/80": variant === "glass",
          "bg-card border border-border shadow-lg hover:shadow-card-hover hover:-translate-y-0.5": variant === "elevated",
        },
        className
      )}
    >
      {children}
    </div>
  );
};
